module.exports = __webpack_public_path__ + "static/media/carousel_quienes_somos_4.286e2013.jpg";